import { memo, useState, useCallback } from "react";
import { ReactSVG } from "react-svg";
import { classNames } from "helpers";

interface CopyButtonProps {
  value: string | number | null | undefined;
  className?: string;
  size?: "sm" | "md";
}

const CopyButton: React.FC<CopyButtonProps> = ({ value, className, size = "sm" }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = useCallback(async (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();

    if (!value) return;

    try {
      await navigator.clipboard.writeText(String(value));
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  }, [value]);

  if (!value) return null;

  const sizeClasses = size === "sm" ? "w-3.5 h-3.5" : "w-4 h-4";

  return (
    <button
      type="button"
      onClick={handleCopy}
      className={classNames(
        "group inline-flex items-center justify-center rounded hover:bg-sky-200 transition-colors p-0.5 ml-1",
        copied ? "text-green-600" : "text-sky-600",
        className
      )}
      title={copied ? "Kopirano!" : "Kopiraj"}
    >
      <ReactSVG
        src={copied ? "/media/icons/check.svg" : "/media/icons/copy.svg"}
        className={classNames(sizeClasses, "stroke-current", !copied && "group-hover:stroke-sky-800")}
      />
    </button>
  );
};

export default memo(CopyButton);